var map = {
	"./characters/cursive/connections/char-ad.png": 542,
	"./characters/cursive/connections/char-bo.png": 543,
	"./characters/cursive/connections/char-by.png": 544,
	"./characters/cursive/connections/char-cc.png": 545,
	"./characters/cursive/connections/char-ch.png": 546,
	"./characters/cursive/connections/char-ed.png": 547,
	"./characters/cursive/connections/char-el.png": 548,
	"./characters/cursive/connections/char-gl.png": 549,
	"./characters/cursive/connections/char-it.png": 550,
	"./characters/cursive/connections/char-oa.png": 551,
	"./characters/cursive/connections/char-oe.png": 552,
	"./characters/cursive/connections/char-of.png": 553,
	"./characters/cursive/connections/char-oi.png": 554,
	"./characters/cursive/connections/char-on.png": 555,
	"./characters/cursive/connections/char-or.png": 556,
	"./characters/cursive/connections/char-os.png": 557,
	"./characters/cursive/connections/char-pa.png": 558,
	"./characters/cursive/connections/char-tr.png": 559,
	"./characters/cursive/connections/char-us.png": 560,
	"./characters/cursive/connections/char-ve.png": 561,
	"./characters/cursive/connections/char-wa.png": 562,
	"./characters/cursive/connections/char-wh.png": 563,
	"./characters/cursive/connections/char-wi.png": 564,
	"./characters/cursive/connections/char-yo.png": 565,
	"./characters/cursive/lowercase/char-a.png": 566,
	"./characters/cursive/lowercase/char-b.png": 567,
	"./characters/cursive/lowercase/char-c.png": 568,
	"./characters/cursive/lowercase/char-d.png": 569,
	"./characters/cursive/lowercase/char-e.png": 570,
	"./characters/cursive/lowercase/char-f.png": 571,
	"./characters/cursive/lowercase/char-g.png": 572,
	"./characters/cursive/lowercase/char-h.png": 573,
	"./characters/cursive/lowercase/char-i.png": 574,
	"./characters/cursive/lowercase/char-j.png": 575,
	"./characters/cursive/lowercase/char-k.png": 576,
	"./characters/cursive/lowercase/char-l.png": 577,
	"./characters/cursive/lowercase/char-m.png": 578,
	"./characters/cursive/lowercase/char-n.png": 579,
	"./characters/cursive/lowercase/char-o.png": 580,
	"./characters/cursive/lowercase/char-p.png": 581,
	"./characters/cursive/lowercase/char-q.png": 582,
	"./characters/cursive/lowercase/char-r.png": 583,
	"./characters/cursive/lowercase/char-s.png": 584,
	"./characters/cursive/lowercase/char-t.png": 585,
	"./characters/cursive/lowercase/char-u.png": 586,
	"./characters/cursive/lowercase/char-v.png": 587,
	"./characters/cursive/lowercase/char-w.png": 588,
	"./characters/cursive/lowercase/char-x.png": 589,
	"./characters/cursive/lowercase/char-y.png": 590,
	"./characters/cursive/lowercase/char-z.png": 591,
	"./characters/cursive/uppercase/char-A.png": 592,
	"./characters/cursive/uppercase/char-B.png": 593,
	"./characters/cursive/uppercase/char-C.png": 594,
	"./characters/cursive/uppercase/char-D.png": 595,
	"./characters/cursive/uppercase/char-E.png": 596,
	"./characters/cursive/uppercase/char-F.png": 597,
	"./characters/cursive/uppercase/char-G.png": 598,
	"./characters/cursive/uppercase/char-H.png": 599,
	"./characters/cursive/uppercase/char-I.png": 600,
	"./characters/cursive/uppercase/char-J.png": 601,
	"./characters/cursive/uppercase/char-K.png": 602,
	"./characters/cursive/uppercase/char-L.png": 603,
	"./characters/cursive/uppercase/char-M.png": 604,
	"./characters/cursive/uppercase/char-N.png": 605,
	"./characters/cursive/uppercase/char-O.png": 606,
	"./characters/cursive/uppercase/char-P.png": 607,
	"./characters/cursive/uppercase/char-Q.png": 608,
	"./characters/cursive/uppercase/char-R.png": 609,
	"./characters/cursive/uppercase/char-S.png": 610,
	"./characters/cursive/uppercase/char-T.png": 611,
	"./characters/cursive/uppercase/char-U.png": 612,
	"./characters/cursive/uppercase/char-V.png": 613,
	"./characters/cursive/uppercase/char-W.png": 614,
	"./characters/cursive/uppercase/char-X.png": 615,
	"./characters/cursive/uppercase/char-Y.png": 616,
	"./characters/cursive/uppercase/char-Z.png": 617,
	"./characters/numbers/char-0.png": 189,
	"./characters/numbers/char-1.png": 190,
	"./characters/numbers/char-2.png": 191,
	"./characters/numbers/char-3.png": 192,
	"./characters/numbers/char-4.png": 193,
	"./characters/numbers/char-5.png": 194,
	"./characters/numbers/char-6.png": 195,
	"./characters/numbers/char-7.png": 196,
	"./characters/numbers/char-8.png": 197,
	"./characters/numbers/char-9.png": 198,
	"./characters/print/lowercase/char-a.png": 225,
	"./characters/print/lowercase/char-b.png": 226,
	"./characters/print/lowercase/char-c.png": 227,
	"./characters/print/lowercase/char-d.png": 228,
	"./characters/print/lowercase/char-e.png": 229,
	"./characters/print/lowercase/char-f.png": 230,
	"./characters/print/lowercase/char-g.png": 231,
	"./characters/print/lowercase/char-h.png": 232,
	"./characters/print/lowercase/char-i.png": 233,
	"./characters/print/lowercase/char-j.png": 234,
	"./characters/print/lowercase/char-k.png": 235,
	"./characters/print/lowercase/char-l.png": 236,
	"./characters/print/lowercase/char-m.png": 237,
	"./characters/print/lowercase/char-n.png": 238,
	"./characters/print/lowercase/char-o.png": 239,
	"./characters/print/lowercase/char-p.png": 240,
	"./characters/print/lowercase/char-q.png": 241,
	"./characters/print/lowercase/char-r.png": 242,
	"./characters/print/lowercase/char-s.png": 243,
	"./characters/print/lowercase/char-t.png": 244,
	"./characters/print/lowercase/char-u.png": 245,
	"./characters/print/lowercase/char-v.png": 246,
	"./characters/print/lowercase/char-w.png": 247,
	"./characters/print/lowercase/char-x.png": 248,
	"./characters/print/lowercase/char-y.png": 249,
	"./characters/print/lowercase/char-z.png": 250,
	"./characters/print/uppercase/char-A.png": 199,
	"./characters/print/uppercase/char-B.png": 200,
	"./characters/print/uppercase/char-C.png": 201,
	"./characters/print/uppercase/char-D.png": 202,
	"./characters/print/uppercase/char-E.png": 203,
	"./characters/print/uppercase/char-F.png": 204,
	"./characters/print/uppercase/char-G.png": 205,
	"./characters/print/uppercase/char-H.png": 206,
	"./characters/print/uppercase/char-I.png": 207,
	"./characters/print/uppercase/char-J.png": 208,
	"./characters/print/uppercase/char-K.png": 209,
	"./characters/print/uppercase/char-L.png": 210,
	"./characters/print/uppercase/char-M.png": 211,
	"./characters/print/uppercase/char-N.png": 212,
	"./characters/print/uppercase/char-O.png": 213,
	"./characters/print/uppercase/char-P.png": 214,
	"./characters/print/uppercase/char-Q.png": 215,
	"./characters/print/uppercase/char-R.png": 216,
	"./characters/print/uppercase/char-S.png": 217,
	"./characters/print/uppercase/char-T.png": 218,
	"./characters/print/uppercase/char-U.png": 219,
	"./characters/print/uppercase/char-V.png": 220,
	"./characters/print/uppercase/char-W.png": 221,
	"./characters/print/uppercase/char-X.png": 222,
	"./characters/print/uppercase/char-Y.png": 223,
	"./characters/print/uppercase/char-Z.png": 224,
	"./lock.png": 618,
	"./plain-stickers/cursive/connection/plain-sticker-ad.png": 309,
	"./plain-stickers/cursive/connection/plain-sticker-bo.png": 310,
	"./plain-stickers/cursive/connection/plain-sticker-by.png": 311,
	"./plain-stickers/cursive/connection/plain-sticker-cc.png": 312,
	"./plain-stickers/cursive/connection/plain-sticker-ch.png": 313,
	"./plain-stickers/cursive/connection/plain-sticker-ed.png": 314,
	"./plain-stickers/cursive/connection/plain-sticker-el.png": 315,
	"./plain-stickers/cursive/connection/plain-sticker-gl.png": 316,
	"./plain-stickers/cursive/connection/plain-sticker-it.png": 317,
	"./plain-stickers/cursive/connection/plain-sticker-oa.png": 318,
	"./plain-stickers/cursive/connection/plain-sticker-oe.png": 319,
	"./plain-stickers/cursive/connection/plain-sticker-of.png": 320,
	"./plain-stickers/cursive/connection/plain-sticker-oi.png": 321,
	"./plain-stickers/cursive/connection/plain-sticker-on.png": 322,
	"./plain-stickers/cursive/connection/plain-sticker-or.png": 323,
	"./plain-stickers/cursive/connection/plain-sticker-os.png": 324,
	"./plain-stickers/cursive/connection/plain-sticker-pa.png": 325,
	"./plain-stickers/cursive/connection/plain-sticker-tr.png": 326,
	"./plain-stickers/cursive/connection/plain-sticker-us.png": 327,
	"./plain-stickers/cursive/connection/plain-sticker-ve.png": 328,
	"./plain-stickers/cursive/connection/plain-sticker-wa.png": 329,
	"./plain-stickers/cursive/connection/plain-sticker-wh.png": 330,
	"./plain-stickers/cursive/connection/plain-sticker-wi.png": 331,
	"./plain-stickers/cursive/connection/plain-sticker-yo.png": 332,
	"./plain-stickers/cursive/lowercase/plain-sticker-a.png": 333,
	"./plain-stickers/cursive/lowercase/plain-sticker-b.png": 334,
	"./plain-stickers/cursive/lowercase/plain-sticker-c.png": 335,
	"./plain-stickers/cursive/lowercase/plain-sticker-d.png": 336,
	"./plain-stickers/cursive/lowercase/plain-sticker-e.png": 337,
	"./plain-stickers/cursive/lowercase/plain-sticker-f.png": 338,
	"./plain-stickers/cursive/lowercase/plain-sticker-g.png": 339,
	"./plain-stickers/cursive/lowercase/plain-sticker-h.png": 340,
	"./plain-stickers/cursive/lowercase/plain-sticker-i.png": 341,
	"./plain-stickers/cursive/lowercase/plain-sticker-j.png": 342,
	"./plain-stickers/cursive/lowercase/plain-sticker-k.png": 343,
	"./plain-stickers/cursive/lowercase/plain-sticker-l.png": 344,
	"./plain-stickers/cursive/lowercase/plain-sticker-m.png": 345,
	"./plain-stickers/cursive/lowercase/plain-sticker-n.png": 346,
	"./plain-stickers/cursive/lowercase/plain-sticker-o.png": 347,
	"./plain-stickers/cursive/lowercase/plain-sticker-p.png": 348,
	"./plain-stickers/cursive/lowercase/plain-sticker-q.png": 349,
	"./plain-stickers/cursive/lowercase/plain-sticker-r.png": 350,
	"./plain-stickers/cursive/lowercase/plain-sticker-s.png": 351,
	"./plain-stickers/cursive/lowercase/plain-sticker-t.png": 352,
	"./plain-stickers/cursive/lowercase/plain-sticker-u.png": 353,
	"./plain-stickers/cursive/lowercase/plain-sticker-v.png": 354,
	"./plain-stickers/cursive/lowercase/plain-sticker-w.png": 355,
	"./plain-stickers/cursive/lowercase/plain-sticker-x.png": 356,
	"./plain-stickers/cursive/lowercase/plain-sticker-y.png": 357,
	"./plain-stickers/cursive/lowercase/plain-sticker-z.png": 358,
	"./plain-stickers/cursive/uppercase/plain-sticker-A.png": 359,
	"./plain-stickers/cursive/uppercase/plain-sticker-B.png": 360,
	"./plain-stickers/cursive/uppercase/plain-sticker-C.png": 361,
	"./plain-stickers/cursive/uppercase/plain-sticker-D.png": 362,
	"./plain-stickers/cursive/uppercase/plain-sticker-E.png": 363,
	"./plain-stickers/cursive/uppercase/plain-sticker-F.png": 364,
	"./plain-stickers/cursive/uppercase/plain-sticker-G.png": 365,
	"./plain-stickers/cursive/uppercase/plain-sticker-H.png": 366,
	"./plain-stickers/cursive/uppercase/plain-sticker-I.png": 367,
	"./plain-stickers/cursive/uppercase/plain-sticker-J.png": 368,
	"./plain-stickers/cursive/uppercase/plain-sticker-K.png": 369,
	"./plain-stickers/cursive/uppercase/plain-sticker-L.png": 370,
	"./plain-stickers/cursive/uppercase/plain-sticker-M.png": 371,
	"./plain-stickers/cursive/uppercase/plain-sticker-N.png": 372,
	"./plain-stickers/cursive/uppercase/plain-sticker-O.png": 373,
	"./plain-stickers/cursive/uppercase/plain-sticker-P.png": 374,
	"./plain-stickers/cursive/uppercase/plain-sticker-Q.png": 375,
	"./plain-stickers/cursive/uppercase/plain-sticker-R.png": 376,
	"./plain-stickers/cursive/uppercase/plain-sticker-S.png": 377,
	"./plain-stickers/cursive/uppercase/plain-sticker-T.png": 378,
	"./plain-stickers/cursive/uppercase/plain-sticker-U.png": 379,
	"./plain-stickers/cursive/uppercase/plain-sticker-V.png": 380,
	"./plain-stickers/cursive/uppercase/plain-sticker-W.png": 381,
	"./plain-stickers/cursive/uppercase/plain-sticker-X.png": 382,
	"./plain-stickers/cursive/uppercase/plain-sticker-Y.png": 383,
	"./plain-stickers/cursive/uppercase/plain-sticker-Z.png": 384,
	"./plain-stickers/numbers/plain-sticker-0.png": 90,
	"./plain-stickers/numbers/plain-sticker-1.png": 91,
	"./plain-stickers/numbers/plain-sticker-2.png": 92,
	"./plain-stickers/numbers/plain-sticker-3.png": 93,
	"./plain-stickers/numbers/plain-sticker-4.png": 94,
	"./plain-stickers/numbers/plain-sticker-5.png": 95,
	"./plain-stickers/numbers/plain-sticker-6.png": 96,
	"./plain-stickers/numbers/plain-sticker-7.png": 97,
	"./plain-stickers/numbers/plain-sticker-8.png": 98,
	"./plain-stickers/numbers/plain-sticker-9.png": 99,
	"./plain-stickers/print/lowercase/plain-sticker-a.png": 126,
	"./plain-stickers/print/lowercase/plain-sticker-b.png": 127,
	"./plain-stickers/print/lowercase/plain-sticker-c.png": 128,
	"./plain-stickers/print/lowercase/plain-sticker-d.png": 129,
	"./plain-stickers/print/lowercase/plain-sticker-e.png": 130,
	"./plain-stickers/print/lowercase/plain-sticker-f.png": 131,
	"./plain-stickers/print/lowercase/plain-sticker-g.png": 132,
	"./plain-stickers/print/lowercase/plain-sticker-h.png": 133,
	"./plain-stickers/print/lowercase/plain-sticker-i.png": 134,
	"./plain-stickers/print/lowercase/plain-sticker-j.png": 135,
	"./plain-stickers/print/lowercase/plain-sticker-k.png": 136,
	"./plain-stickers/print/lowercase/plain-sticker-l.png": 137,
	"./plain-stickers/print/lowercase/plain-sticker-m.png": 138,
	"./plain-stickers/print/lowercase/plain-sticker-n.png": 139,
	"./plain-stickers/print/lowercase/plain-sticker-o.png": 140,
	"./plain-stickers/print/lowercase/plain-sticker-p.png": 141,
	"./plain-stickers/print/lowercase/plain-sticker-q.png": 142,
	"./plain-stickers/print/lowercase/plain-sticker-r.png": 143,
	"./plain-stickers/print/lowercase/plain-sticker-s.png": 144,
	"./plain-stickers/print/lowercase/plain-sticker-t.png": 145,
	"./plain-stickers/print/lowercase/plain-sticker-u.png": 146,
	"./plain-stickers/print/lowercase/plain-sticker-v.png": 147,
	"./plain-stickers/print/lowercase/plain-sticker-w.png": 148,
	"./plain-stickers/print/lowercase/plain-sticker-x.png": 149,
	"./plain-stickers/print/lowercase/plain-sticker-y.png": 150,
	"./plain-stickers/print/lowercase/plain-sticker-z.png": 151,
	"./plain-stickers/print/uppercase/plain-sticker-A.png": 100,
	"./plain-stickers/print/uppercase/plain-sticker-B.png": 101,
	"./plain-stickers/print/uppercase/plain-sticker-C.png": 102,
	"./plain-stickers/print/uppercase/plain-sticker-D.png": 103,
	"./plain-stickers/print/uppercase/plain-sticker-E.png": 104,
	"./plain-stickers/print/uppercase/plain-sticker-F.png": 105,
	"./plain-stickers/print/uppercase/plain-sticker-G.png": 106,
	"./plain-stickers/print/uppercase/plain-sticker-H.png": 107,
	"./plain-stickers/print/uppercase/plain-sticker-I.png": 108,
	"./plain-stickers/print/uppercase/plain-sticker-J.png": 109,
	"./plain-stickers/print/uppercase/plain-sticker-K.png": 110,
	"./plain-stickers/print/uppercase/plain-sticker-L.png": 111,
	"./plain-stickers/print/uppercase/plain-sticker-M.png": 112,
	"./plain-stickers/print/uppercase/plain-sticker-N.png": 113,
	"./plain-stickers/print/uppercase/plain-sticker-O.png": 114,
	"./plain-stickers/print/uppercase/plain-sticker-P.png": 115,
	"./plain-stickers/print/uppercase/plain-sticker-Q.png": 116,
	"./plain-stickers/print/uppercase/plain-sticker-R.png": 117,
	"./plain-stickers/print/uppercase/plain-sticker-S.png": 118,
	"./plain-stickers/print/uppercase/plain-sticker-T.png": 119,
	"./plain-stickers/print/uppercase/plain-sticker-U.png": 120,
	"./plain-stickers/print/uppercase/plain-sticker-V.png": 121,
	"./plain-stickers/print/uppercase/plain-sticker-W.png": 122,
	"./plain-stickers/print/uppercase/plain-sticker-X.png": 123,
	"./plain-stickers/print/uppercase/plain-sticker-Y.png": 124,
	"./plain-stickers/print/uppercase/plain-sticker-Z.png": 125,
	"./star-empty.png": 619,
	"./star-filled.png": 620,
	"./stickers/cursive/connections/sticker-ad.png": 621,
	"./stickers/cursive/connections/sticker-bo.png": 622,
	"./stickers/cursive/connections/sticker-by.png": 623,
	"./stickers/cursive/connections/sticker-cc.png": 624,
	"./stickers/cursive/connections/sticker-ch.png": 625,
	"./stickers/cursive/connections/sticker-ed.png": 626,
	"./stickers/cursive/connections/sticker-el.png": 627,
	"./stickers/cursive/connections/sticker-gl.png": 628,
	"./stickers/cursive/connections/sticker-it.png": 629,
	"./stickers/cursive/connections/sticker-oa.png": 630,
	"./stickers/cursive/connections/sticker-oe.png": 631,
	"./stickers/cursive/connections/sticker-of.png": 632,
	"./stickers/cursive/connections/sticker-oi.png": 633,
	"./stickers/cursive/connections/sticker-on.png": 634,
	"./stickers/cursive/connections/sticker-or.png": 635,
	"./stickers/cursive/connections/sticker-os.png": 636,
	"./stickers/cursive/connections/sticker-pa.png": 637,
	"./stickers/cursive/connections/sticker-tr.png": 638,
	"./stickers/cursive/connections/sticker-us.png": 639,
	"./stickers/cursive/connections/sticker-ve.png": 640,
	"./stickers/cursive/connections/sticker-wa.png": 641,
	"./stickers/cursive/connections/sticker-wh.png": 642,
	"./stickers/cursive/connections/sticker-wi.png": 643,
	"./stickers/cursive/connections/sticker-yo.png": 644,
	"./stickers/cursive/lowercase/sticker-a.png": 645,
	"./stickers/cursive/lowercase/sticker-b.png": 646,
	"./stickers/cursive/lowercase/sticker-c.png": 647,
	"./stickers/cursive/lowercase/sticker-d.png": 648,
	"./stickers/cursive/lowercase/sticker-e.png": 649,
	"./stickers/cursive/lowercase/sticker-f.png": 650,
	"./stickers/cursive/lowercase/sticker-g.png": 651,
	"./stickers/cursive/lowercase/sticker-h.png": 652,
	"./stickers/cursive/lowercase/sticker-i.png": 653,
	"./stickers/cursive/lowercase/sticker-j.png": 654,
	"./stickers/cursive/lowercase/sticker-k.png": 655,
	"./stickers/cursive/lowercase/sticker-l.png": 656,
	"./stickers/cursive/lowercase/sticker-m.png": 657,
	"./stickers/cursive/lowercase/sticker-n.png": 658,
	"./stickers/cursive/lowercase/sticker-o.png": 659,
	"./stickers/cursive/lowercase/sticker-p.png": 660,
	"./stickers/cursive/lowercase/sticker-q.png": 661,
	"./stickers/cursive/lowercase/sticker-r.png": 662,
	"./stickers/cursive/lowercase/sticker-s.png": 663,
	"./stickers/cursive/lowercase/sticker-t.png": 664,
	"./stickers/cursive/lowercase/sticker-u.png": 665,
	"./stickers/cursive/lowercase/sticker-v.png": 666,
	"./stickers/cursive/lowercase/sticker-w.png": 667,
	"./stickers/cursive/lowercase/sticker-x.png": 668,
	"./stickers/cursive/lowercase/sticker-y.png": 669,
	"./stickers/cursive/lowercase/sticker-z.png": 670,
	"./stickers/cursive/uppercase/sticker-A.png": 671,
	"./stickers/cursive/uppercase/sticker-B.png": 672,
	"./stickers/cursive/uppercase/sticker-C.png": 673,
	"./stickers/cursive/uppercase/sticker-D.png": 674,
	"./stickers/cursive/uppercase/sticker-E.png": 675,
	"./stickers/cursive/uppercase/sticker-F.png": 676,
	"./stickers/cursive/uppercase/sticker-G.png": 677,
	"./stickers/cursive/uppercase/sticker-H.png": 678,
	"./stickers/cursive/uppercase/sticker-I.png": 679,
	"./stickers/cursive/uppercase/sticker-J.png": 680,
	"./stickers/cursive/uppercase/sticker-K.png": 681,
	"./stickers/cursive/uppercase/sticker-L.png": 682,
	"./stickers/cursive/uppercase/sticker-M.png": 683,
	"./stickers/cursive/uppercase/sticker-N.png": 684,
	"./stickers/cursive/uppercase/sticker-O.png": 685,
	"./stickers/cursive/uppercase/sticker-P.png": 686,
	"./stickers/cursive/uppercase/sticker-Q.png": 687,
	"./stickers/cursive/uppercase/sticker-R.png": 688,
	"./stickers/cursive/uppercase/sticker-S.png": 689,
	"./stickers/cursive/uppercase/sticker-T.png": 690,
	"./stickers/cursive/uppercase/sticker-U.png": 691,
	"./stickers/cursive/uppercase/sticker-V.png": 692,
	"./stickers/cursive/uppercase/sticker-W.png": 693,
	"./stickers/cursive/uppercase/sticker-X.png": 694,
	"./stickers/cursive/uppercase/sticker-Y.png": 695,
	"./stickers/cursive/uppercase/sticker-Z.png": 696,
	"./stickers/numbers/sticker-0.png": 697,
	"./stickers/numbers/sticker-1.png": 698,
	"./stickers/numbers/sticker-2.png": 699,
	"./stickers/numbers/sticker-3.png": 700,
	"./stickers/numbers/sticker-4.png": 701,
	"./stickers/numbers/sticker-5.png": 702,
	"./stickers/numbers/sticker-6.png": 703,
	"./stickers/numbers/sticker-7.png": 704,
	"./stickers/numbers/sticker-8.png": 705,
	"./stickers/numbers/sticker-9.png": 706,
	"./stickers/print/lowercase/sticker-a.png": 278,
	"./stickers/print/lowercase/sticker-b.png": 279,
	"./stickers/print/lowercase/sticker-c.png": 280,
	"./stickers/print/lowercase/sticker-d.png": 281,
	"./stickers/print/lowercase/sticker-e.png": 282,
	"./stickers/print/lowercase/sticker-f.png": 283,
	"./stickers/print/lowercase/sticker-g.png": 284,
	"./stickers/print/lowercase/sticker-h.png": 285,
	"./stickers/print/lowercase/sticker-i.png": 286,
	"./stickers/print/lowercase/sticker-j.png": 287,
	"./stickers/print/lowercase/sticker-k.png": 288,
	"./stickers/print/lowercase/sticker-l.png": 289,
	"./stickers/print/lowercase/sticker-m.png": 290,
	"./stickers/print/lowercase/sticker-n.png": 291,
	"./stickers/print/lowercase/sticker-o.png": 292,
	"./stickers/print/lowercase/sticker-p.png": 293,
	"./stickers/print/lowercase/sticker-q.png": 294,
	"./stickers/print/lowercase/sticker-r.png": 295,
	"./stickers/print/lowercase/sticker-s.png": 296,
	"./stickers/print/lowercase/sticker-t.png": 297,
	"./stickers/print/lowercase/sticker-u.png": 298,
	"./stickers/print/lowercase/sticker-v.png": 299,
	"./stickers/print/lowercase/sticker-w.png": 300,
	"./stickers/print/lowercase/sticker-x.png": 301,
	"./stickers/print/lowercase/sticker-y.png": 302,
	"./stickers/print/lowercase/sticker-z.png": 303,
	"./stickers/print/uppercase/sticker-A.png": 252,
	"./stickers/print/uppercase/sticker-B.png": 253,
	"./stickers/print/uppercase/sticker-C.png": 254,
	"./stickers/print/uppercase/sticker-D.png": 255,
	"./stickers/print/uppercase/sticker-E.png": 256,
	"./stickers/print/uppercase/sticker-F.png": 257,
	"./stickers/print/uppercase/sticker-G.png": 258,
	"./stickers/print/uppercase/sticker-H.png": 259,
	"./stickers/print/uppercase/sticker-I.png": 260,
	"./stickers/print/uppercase/sticker-J.png": 261,
	"./stickers/print/uppercase/sticker-K.png": 262,
	"./stickers/print/uppercase/sticker-L.png": 263,
	"./stickers/print/uppercase/sticker-M.png": 264,
	"./stickers/print/uppercase/sticker-N.png": 265,
	"./stickers/print/uppercase/sticker-O.png": 266,
	"./stickers/print/uppercase/sticker-P.png": 267,
	"./stickers/print/uppercase/sticker-Q.png": 268,
	"./stickers/print/uppercase/sticker-R.png": 269,
	"./stickers/print/uppercase/sticker-S.png": 270,
	"./stickers/print/uppercase/sticker-T.png": 271,
	"./stickers/print/uppercase/sticker-U.png": 272,
	"./stickers/print/uppercase/sticker-V.png": 273,
	"./stickers/print/uppercase/sticker-W.png": 274,
	"./stickers/print/uppercase/sticker-X.png": 275,
	"./stickers/print/uppercase/sticker-Y.png": 276,
	"./stickers/print/uppercase/sticker-Z.png": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 541;